import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	EndorsementsGetEndorsementsQuery,
	EndorsementsGetEndorsementsQueryVariables,
} from './getEndorsements.graphql';
import { EndorsementsGetEndorsements } from './getEndorsements.graphql';

export type Endorsement = NonNullable<
	NonNullable<EndorsementsGetEndorsementsQuery['petition']>['endorsementsConnection']['nodes'][number]
>;

export type GetEndorsementsResponse = {
	petitionId: string;
	totalCount: number;
	endorsements: readonly Endorsement[];
};

export async function getEndorsements(
	slugOrId: string,
	first: number,
	{ gql: { fetch } }: UtilityContext,
): Promise<GetEndorsementsResponse> {
	const { data } = await fetch<EndorsementsGetEndorsementsQuery, EndorsementsGetEndorsementsQueryVariables>({
		query: EndorsementsGetEndorsements,
		variables: { slugOrId, first },
		rejectOnError: true,
	});
	if (!data?.petition) throw new Error('Petition not found');

	return {
		petitionId: data.petition.id,
		totalCount: data.petition.endorsementsConnection.totalCount,
		endorsements: data.petition.endorsementsConnection.nodes,
	};
}
